<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Pendientes Beta"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        // {
        //     type        :   'button',
        //     class       :   'btn btn-xs btn-info pull-right',
        //     route       :   'AuthorsCreate',
        //     text        :   '<i class="fa fa-plus">',
        //     description :   '<i class="fa fa-plus">',
        // }
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        f___fecha: "",
        f___hora: "",
        f___codigo_ficha: "",
        f___descripcion: "",
        f___tipo_nc_codi: "",
        e___descripcion: "",
        z___razon: "",
      },
      busquedaTraduccion: {
        f___fecha: this.$root.trans("Fecha"),
        f___hora: this.$root.trans("Hora"),
        f___codigo_ficha: this.$root.trans("Codigo"),
        f___descripcion: this.$root.trans("Descripción"),
        f___tipo_nc_codi: this.$root.trans("Tipo de Registro"),
        e___descripcion: this.$root.trans("Etapa Actual"),
        z___razon: this.$root.trans("Sujeto"),
      },
      busquedaCampos: {
        f___tipo_nc_codi: {
          type: "select",
          options: [],
        },
        e___descripcion: {
          type: "select",
          options: [],
        },
      },
      busquedaMedidas: {
        f___fecha: "90px",
        f___hora: "90px",
        f___codigo_ficha: "90px",
        f___descripcion: "180px",
        f___tipo_nc_codi: "160px",
        e___descripcion: "160px",
        z___razon: "160px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        // User: {},
        generic1: {
          code: "codigo",
          label: "descripcion",
          model: "TipoNC",
          order: "descripcion",
          nc: "RE",
        },
        generic2: {
          code: "descripcion",
          label: "descripcion",
          model: "FichasEtapaNC",
          order: "descripcion",
          nc: "RE",
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.f___tipo_nc_codi.options = response.generic1;
        this.busquedaCampos.e___descripcion.options = response.generic2;
      });
  },
};
</script>
